import '@Ui/responsive-global.scss';

import { setInitConfig, unmountOdsClient } from '@App/init/initEvents';
import { renderClient, renderLegacyClient } from '@App/init/initOdsClientRender';
import { CoreShopEnvironment } from '@App/Main.types';
import { deleteBranchPreviewName, deleteBranchPreviewUrl, getBranchPreviewConfig } from '@Framework/branchPreview';
import { CURRENT_SCRIPT_BRANCH } from '@Framework/constants';
import React from 'react';

// Used to check if loaded branch is valid/exists
async function fetchLoadedBranchSource(url: string) {
  return await fetch(url, {
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
}

const clearBranchValues = () => {
  deleteBranchPreviewUrl();
  deleteBranchPreviewName();
  // TODO
  // Make sure to check for future bugs if base url changes
  const prevParam = location.pathname.split('/')[1];
  location.href = `/${prevParam}/branch-preview/?invalidBranch=true`;
};

let delayLoadTrigger = false;

window['_odsCurrentScriptBranch'] = CURRENT_SCRIPT_BRANCH;

if (process.env.REACT_APP_CORE_SHOP_ENVIRONMENT !== CoreShopEnvironment.Prod) {
  const branchPreview = getBranchPreviewConfig();
  let loadedBranchSource;
  const srcUrl = document.currentScript?.attributes['src'].value;

  if (branchPreview.branchPreviewUrl !== undefined) {
    if (srcUrl !== branchPreview.branchPreviewUrl) {
      loadedBranchSource = branchPreview.branchPreviewUrl;
    }
  }

  if (branchPreview.branchPreviewName !== undefined) {
    loadedBranchSource = process.env.REACT_APP_FEATURE_PREVIEW_SOURCE?.replace(
      '__BRANCH_NAME__',
      branchPreview.branchPreviewName
    );
  }

  if (loadedBranchSource !== undefined && srcUrl !== loadedBranchSource) {
    delayLoadTrigger = true;
    const script = document.createElement('script');
    script.src = loadedBranchSource;
    document.head.appendChild(script);
    setTimeout(() => {
      if (
        branchPreview.branchPreviewUrl === undefined &&
        branchPreview.branchPreviewName !== window['_odsCurrentScriptBranch']
      ) {
        loadedBranchSource = '';
        delayLoadTrigger = false;
        clearBranchValues();
      }
    }, 4 * 1000); // wait 4 seconds to load error page
  }
}

let initOdsClient: any = undefined;
if (!delayLoadTrigger) {
  if (module.hot) {
    module.hot.accept();
  }

  window['odsClientRender'] = (containerElement: Element) => {
    const initConfig = setInitConfig();
    renderClient(containerElement, initConfig);
  };

  initOdsClient = renderClient;

  window['odsClientUnmount'] = unmountOdsClient;

  // Inits <div id="ods-client">...
  // Which is used as containerElement
  renderLegacyClient();

  const odsScriptLoadedEvent = new CustomEvent('odsClientScriptLoaded');
  document.dispatchEvent(odsScriptLoadedEvent);
}

export default initOdsClient;
